var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconHangup = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .hangup_a {\n                fill: #e62e3d;\n            }\n\n            ,\n            .hangup_b {\n                fill-rule: evenodd;\n            }\n\n            .hangup_b {\n                fill: #fff;\n            }\n\n            .hangup_c {\n                fill: none !important;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.155 -0.418)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.845 3.418)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "hangup_a",
    d: "M92.21,1016.42A19.21,19.21,0,1,0,73,997.21,19.211,19.211,0,0,0,92.21,1016.42Z",
    transform: "translate(-73 -978)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hangup_b",
    d: "M104.64,992l-3.649,3.647a1.871,1.871,0,0,1-2.643,0,11.608,11.608,0,0,0-3.5-2.4,1.872,1.872,0,0,1-1.079-2.068l.187-.956-.08-.025a14.26,14.26,0,0,0-7.375-.048l-.091.025.168.981a1.871,1.871,0,0,1-.916,1.942l-.192.1a11.6,11.6,0,0,0-3.63,2.448,1.87,1.87,0,0,1-2.642,0L75.548,992a1.873,1.873,0,0,1,0-2.647,20.574,20.574,0,0,1,29.092,0A1.873,1.873,0,0,1,104.64,992Zm-8.475-.192a13.494,13.494,0,0,1,3.5,2.516l3.649-3.648-.357-.347a18.7,18.7,0,0,0-26.09.347l3.649,3.648.464-.44a13.514,13.514,0,0,1,3.75-2.4l-.443-2.576.521-.189a16.131,16.131,0,0,1,11.288.269l-.5,2.558Z",
    transform: "translate(-70.884 -970.983)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "hangup_c",
    width: 44,
    height: 44,
    transform: "translate(-0.155 0.418)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconHangup);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_hangup.aa3c252af6c5226bbaf3908766dd0ba0.svg";